import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllBlogs.css";

import bhElectricFleet from "../../../assets/img/electric-trimmer.jpg";
import bhGreenPractice from "../../../assets/img/lawn-health.jpg";

export default function EcoFriendlyLawnCareBlog() {
  const location = useLocation();

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "Eco-Friendly Lawn Care: How BUR-HAN is Changing Vancouver Landscapes Blog";
    document.title = newTitle;

    const newDescription = "Discover how BUR-HAN's all-electric STIHL fleet is revolutionizing Vancouver lawn care with zero emissions, reduced noise pollution, and sustainable practices for a greener city.";
    const descriptionMetaTag = document.querySelector(
      'meta[name="description"]'
    );
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "eco-friendly lawn care Vancouver, electric landscaping equipment, sustainable lawn maintenance, zero emission landscaping, green landscaping services, electric mowers Vancouver, battery-powered lawn care, environmentally friendly landscaping, sustainable garden care, electric lawn equipment BC, clean air landscaping, quiet lawn maintenance, eco landscaping company, green lawn services, sustainable property maintenance",
    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector(
      'meta[property="og:description"]'
    );
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="beforeSection"></div>
      <div className="sectionBlogpost ecoFriendly">
        <a href="/blog" className="backPosts">
          <i className="bi bi-arrow-left"></i>
          Back
        </a>
        <article>
          <header>
            <h1>
              <div className="nth-line-1" data-aos="fade-up">
                Eco-Friendly Lawn Care:
              </div>
              <div className="nth-line-2" data-aos="fade-up">
                How BUR-HAN's Electric Fleet is Changing
                <br />
                Vancouver Landscapes
              </div>
            </h1>
            <p className="lead" data-aos="fade-right">
              Join the green revolution transforming Vancouver's outdoor spaces
            </p>
          </header>
          <hr />
          <section data-aos="fade-right">
            <p>
              Vancouver is known for its stunning natural beauty and 
              environmental consciousness. At BUR-HAN, we're proud to 
              align with these values by revolutionizing lawn care with 
              British Columbia's largest fleet of STIHL electric equipment. 
              Our commitment to sustainability isn't just about keeping up 
              with trends—it's about leading the charge toward a cleaner, 
              quieter, and healthier Vancouver.
            </p>
            
            <img loading="lazy"
              src={bhElectricFleet}
              alt="BUR-HAN's complete electric STIHL fleet lined up - zero emission lawn care equipment in Vancouver"
              title="BUR-HAN's All-Electric STIHL Fleet - Sustainable Landscaping Equipment"
              width={"90% !important"}
            />

            <h2>The Electric Revolution in Professional Lawn Care</h2>
            <p>
              <span>The Electric Revolution in Lawn Care</span>
              <br />
              We've completely transformed our operations by replacing 
              75 gas-powered machines with state-of-the-art STIHL battery 
              equipment. This isn't just a minor upgrade—it's a fundamental 
              shift in how professional lawn care can and should be done. 
              Here's what this means for our community:
            </p>

            <p>
              <span>1. Zero Emissions for Cleaner Air</span>
              <br />
              Traditional gas-powered lawn equipment emits harmful pollutants 
              including carbon monoxide, nitrogen oxides, and volatile organic 
              compounds. In fact, according to Metro Vancouver studies, 
              operating a gas lawn mower for one hour can produce the same 
              amount of pollution as driving a car for hundreds of kilometers.
              <br />
              <br />
              Our electric fleet eliminates these emissions at the source. 
              Every BUR-HAN service now contributes to cleaner air in your 
              neighborhood, helping reduce the environmental impact of 
              property maintenance while maintaining the professional quality 
              you expect.
            </p>

            <p>
              <span>2. Significant Noise Reduction</span>
              <br />
              The constant drone of gas-powered equipment has become an 
              unavoidable part of urban life—until now. Our STIHL battery 
              equipment operates at significantly lower decibel levels, 
              transforming the lawn care experience from disruptive to 
              barely noticeable.
              <br />
              <br />
              This means early morning or late evening maintenance no longer 
              disturbs your peace, and conversations can continue uninterrupted 
              while we work. It's lawn care that respects your peace and 
              your time.
            </p>

            <h2>BUR-HAN's Comprehensive Green Lawn Care Practices</h2>
            <p>
              <span>3. Beyond Electric: Our Comprehensive Green Practices</span>
              <br />
              Our commitment to sustainability extends far beyond just 
              switching to electric equipment. For over 30 years, we've 
              implemented eco-friendly practices that include:
              <br />
              <br />
              • <strong>Chemical-Free Maintenance:</strong> Complete elimination 
              of harmful herbicides and pesticides, protecting your family, 
              pets, and local ecosystems
              <br />
              • <strong>Smart Routing Technology:</strong> GPS-optimized routes 
              that reduce fuel consumption and vehicle emissions
              <br />
              <img loading="lazy"
              src={bhGreenPractice}
              alt="BUR-HAN team practicing sustainable landscaping with electric equipment in Vancouver garden"
              title="Sustainable Landscaping Practices with Electric Equipment"
              width={"90% !important"}
            />
              • <strong>Water Conservation:</strong> Implementing landscaping 
              designs and maintenance practices that reduce water usage
              <br />
              • <strong>Biodiversity Promotion:</strong> Creating landscapes 
              that support local pollinators and wildlife
              <br />
              • <strong>Waste Reduction:</strong> Comprehensive recycling and 
              composting of green waste
            </p>

            <p>
              <span>4. Power Without Compromise</span>
              <br />
              Some might worry that electric means less powerful, but our 
              STIHL professional-grade equipment delivers performance that 
              matches—and in many cases exceeds—traditional gas tools. Our 
              team reports better torque, instant start capability, and 
              consistent power delivery throughout the battery life.
              <br />
              <br />
              The maintenance is simpler too: no more spark plugs, air filters, 
              or oil changes. This means more reliable service and less 
              downtime for your property maintenance.
            </p>

            <p>
              <span>5. Aligning with Vancouver's Green Future</span>
              <br />
              Our transition to electric equipment aligns perfectly with 
              Metro Vancouver's environmental goals and the growing demand 
              for sustainable business practices. We're not just following 
              regulations—we're anticipating them and setting new standards 
              for our industry.
              <br />
              <br />
              By choosing BUR-HAN, you're supporting a local business that 
              invests in Vancouver's environmental future. You're helping 
              create demand for green technologies and demonstrating that 
              sustainable choices can be practical, powerful, and professional.
            </p>

            <h2>Join Vancouver's Eco-Friendly Lawn Care Movement</h2>
            <p>
              <span>Join the Movement</span>
              <br />
              Every property we maintain with our electric fleet is a step 
              toward a cleaner, quieter, and more sustainable Vancouver. 
              From residential gardens to commercial properties, schools, 
              and public spaces, we're proving that professional lawn care 
              can be both effective and environmentally responsible.
              <br />
              <br />
              <strong>Ready to make your property maintenance part of the solution?</strong> 
              Choose BUR-HAN and experience the difference that truly 
              eco-friendly lawn care can make.
            </p>
          </section>
        </article>
        <div className="relatedArticles">
          <h3>Related Articles</h3>
          <ul>
            <li><a href="/blog/organic-vs-synthetic-fertilizer-vancouver">Organic vs Synthetic Fertilizer: What's Best for Vancouver Lawns?</a></li>
            <li><a href="/blog/spring-lawn-care-checklist-vancouver">Spring Lawn Care Checklist for Greater Vancouver Homeowners</a></li>
            <li><a href="/blog/sustainable-landscaping-a-vision-for-north-and-west-vancouver">Sustainable Landscaping: A Vision for North and West Vancouver</a></li>
          </ul>
        </div>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to go green with your lawn care?</h3>
                <p>
                  Join Vancouver's sustainable landscaping movement. Get a 
                  personalized estimate for eco-friendly property maintenance 
                  that protects our environment while enhancing your outdoor space.
                </p>
              </div>
              <div className="col-md-6 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Go Green Today
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}